<template>
  <div>

    <b-row>
      <b-col>
        <b-card class="mb-2">
          <b-row>
            <b-col cols="10" class="h3 mb-1">
              <span variant="primary">Configuración de Ciclos Lectivos</span>
            </b-col>
            <!-- <b-col>
              <b-button @click="syncYear()">sincronizar</b-button>
            </b-col> -->
            <b-col>
              <b-button v-b-modal.modal-1 variant="primary" class="m-1">
                <b-iconstack font-scale="1" class="ml-1" title="Nuevo Ciclo Lectivo">
                  <b-icon stacked icon="plus" shift-h="-15"></b-icon>
                  <b-icon stacked icon="calendar-week-fill"></b-icon>
                </b-iconstack>
                <span class="ml-2">Nuevo Ciclo Lectivo</span>
              </b-button>
              <b-modal id="modal-1" title="Nuevo Ciclo Lectivo">
                <p class="my-4" v-if="!isLoading">
                  Este proceso va a copiar el ultimo año cargado con todas sus configuraciones para luego poder editar
                  las
                  fechas
                  de
                  los mismos. <br>

                  <b-button @click="guardarCopiaAño()">Copiar estructura de ultimo año</b-button>
                </p>
                <template v-if="!isLoading" #modal-footer="{ cancel }">
                  <b-button @click="cancel()"> Cerrar </b-button>
                </template>
              </b-modal>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-table :items="years" class="mt-2 text-center" sticky-header no-border-collapse head-variant="light"
      :fields="yearsFields" striped style="min-height: 60vh;" v-if="!isLoading">
      <template #cell(x_clase_ids)="data">
        {{ data.item.x_clase_ids.length }}
      </template>
      <template #cell(x_enrollment_ids)="data">
        {{ data.item.x_enrollment_ids.length }}
      </template>
      <template #cell(actions)="data">
        <b-button @click="configurarPopUp(data.item)">Configurar</b-button>
        <b-button v-if="data.item.x_enrollment_ids.length == 0" @click="eliminarAño(data.item)">Eliminar</b-button>
      </template>
    </b-table>
    <b-modal id="modal-configure-year" size="xl" :title="modalTitle">
      <b-row>
        <b-col>
          <h3>Periodos</h3>
        </b-col>
      </b-row>
      <div v-if="editItem.id !== undefined && !isLoading">
        <b-card>
          <b-row>
            <b-col>Nombre: <b-input v-model="editItem.x_name"></b-input></b-col>
            <b-col>
              <div @click="cancerlarEditarPeriodo()">Cancelar</div>
            </b-col>
            <b-col> <b-button @click="guardarEditarPeriodo()">Guardar</b-button></b-col>

          </b-row>
          <b-row>
            <b-col>Desde: <b-input type="date" v-model="editItem.x_start_date"></b-input> </b-col>
            <b-col>Hasta: <b-input type="date" v-model="editItem.x_end_date"></b-input></b-col>
            <b-col>Tipo: <b-input v-model="editItem.x_type"></b-input></b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Cursos Inferiores</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col @click="nuevaScoreTypeInf()">
              Nuevo
            </b-col>
          </b-row>
          <b-row>
            <b-col v-for="(v2, k2) in editItem.x_score_types" :key="'scoretype' + k2">
              <b-row>
                <b-col>Nombre: <b-input v-model="editItem.x_score_types[k2].x_name"></b-input></b-col>
              </b-row>
              <b-row>
                <b-col>Orden: <b-input v-model="editItem.x_score_types[k2].x_order"></b-input></b-col>
              </b-row>
              <b-row>
                <b-col>Promociona: <b-input v-model="editItem.x_score_types[k2].x_promotion"></b-input></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Cursos Superiores</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col @click="nuevaScoreTypeSup()">
              Nuevo
            </b-col>
          </b-row>
          <b-row>
            <b-col v-for="(v2, k2) in editItem.x_score_types_adv" :key="'scoretype' + k2">
              <b-row>
                <b-col>Nombre: <b-input v-model="editItem.x_score_types_adv[k2].x_name"></b-input></b-col>
              </b-row>
              <b-row>
                <b-col>Orden: <b-input v-model="editItem.x_score_types_adv[k2].x_order"></b-input></b-col>
              </b-row>
              <b-row>
                <b-col>Promociona: <b-input v-model="editItem.x_score_types_adv[k2].x_promotion"></b-input></b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <div v-if="editItem.id == undefined">
        <div v-for="(v, k) in modalPeriods" :key="'period' + k" style="margin-bottom:15px">
          <b-card>
            <b-row>
              <b-col>
                <h4>{{ v.display_name }}</h4>
              </b-col>
              <b-col> <b-button @click="editarPeriodo(v)">Editar</b-button></b-col>
              <!-- <b-col> <b-button @click="eliminarPeriodo(v)">Eliminar</b-button></b-col> -->
            </b-row>
            <b-row>
              <b-col>Desde: {{ v.x_start_date }}</b-col>
              <b-col>Hasta: {{ v.x_end_date }}</b-col>
              <b-col>Tipo: {{ v.x_type }}</b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5>Cursos Inferiores</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-for="(v2, k2) in v.x_score_types" :key="'scoretype' + k2">
                <b-row>
                  <b-col>Nombre:({{ v2.id }}) {{ v2.x_name }}</b-col>
                </b-row>
                <b-row>
                  <b-col>Orden: {{ v2.x_order }}</b-col>
                </b-row>
                <b-row>
                  <b-col>Promociona: {{ v2.x_promotion }}</b-col>
                </b-row>
                <b-row>
                  <b-col @click="deleteScoreType(v2.id)">
                    <b-button @click="deleteScoreType(v2.id)">ELIMINAR</b-button></b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5>Cursos Superiores</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-for="(v2, k2) in v.x_score_types_adv" :key="'scoretype' + k2">
                <b-row>
                  <b-col>Nombre:({{ v2.id }}) {{ v2.x_name }}</b-col>
                </b-row>
                <b-row>
                  <b-col>Orden: {{ v2.x_order }}</b-col>
                </b-row>
                <b-row>
                  <b-col>Promociona: {{ v2.x_promotion }}</b-col>
                </b-row>
                <b-row>
                  <b-button @click="deleteScoreType(v2.id)">ELIMINAR</b-button>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <div>
          <b-card>
            <div @click="nuevoPeriodo()">NUEVO</div>
          </b-card>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()"> Cerrar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { YearsService } from '@/services/years.service'
import { PeriodsService } from '@/services/periods.service'
import { ScoreTypeService } from '@/services/score.type.service'
// import { parse } from 'path'
import moment from 'moment'

export default {
  name: 'ConfigYears',
  data () {
    return {
      isLoading: true,
      years: [],
      yearsFields: [
        { key: 'x_year', label: 'Año', sortable: true },
        { key: 'x_clase_ids', label: 'Clases' },
        { key: 'x_enrollment_ids', label: 'Inscripciones' },
        { key: 'actions', label: 'Acciones' }
      ],
      selectedYear: {},
      modalTitle: '',
      modalItem: {},
      modalPeriods: [],
      editItem: {}
    }
  },
  watch: {},
  computed: {},
  async created () {
    this.isLoading = true
    await this.updateLista()
    this.isLoading = false
  },
  methods: {
    async eliminarAño (year) {
      console.log(year)
      this.isLoading = true
      for (const index in year.x_period_ids) {
        const id = year.x_period_ids[index]
        await PeriodsService.delete([id])
      }
      await YearsService.delete([year.id])
      await this.updateLista()
      this.isLoading = false
    },
    async guardarCopiaAño () {
      this.isLoading = true
      const newYearId = await YearsService.create({ x_year: (parseInt(this.years[this.years.length - 1].x_year) + 1) })
      const periods = await PeriodsService.read(this.years[this.years.length - 1].x_period_ids)
      periods.sort((a, b) => {
        const dateA = new Date(a.x_end_date)
        const dateB = new Date(b.x_end_date)
        if (dateA < dateB) {
          return -1
        }
        if (dateA > dateB) {
          return 1
        }
        return 0
      })
      for (const periodIndex in periods) {
        const item = periods[periodIndex]
        const newPeriod = {
          x_year_id: newYearId,
          x_name: item.x_name,
          x_type: item.x_type,
          x_start_date: moment(item.x_start_date).add(1, 'years').format('YYYY-MM-DD'),
          x_end_date: moment(item.x_end_date).add(1, 'years').format('YYYY-MM-DD')
        }
        const newPeriodId = await PeriodsService.create(newPeriod)
        const scoreTypes = await ScoreTypeService.list({ x_period_id: item.id })
        console.log(scoreTypes, newPeriodId)
        for (const st of scoreTypes) {
          const newSt = {
            x_period_id: newPeriodId,
            x_order: st.x_order,
            x_name: st.x_name,
            x_advanced_class: st.x_advanced_class
          }
          await ScoreTypeService.create(newSt)
        }
      }
      await this.updateLista()
      this.isLoading = false
    },
    async duplicarPeriodo (item) {
      console.log(item)
      item.id = ''
      for (let i = 0; i < item.x_score_types.length; i++) {
        item.x_score_types[i].id = ''
      }
      for (let i = 0; i < item.x_score_types_adv.length; i++) {
        item.x_score_types_adv[i].id = ''
      }
      this.editItem = item
    },
    async eliminarPeriodo (item) {
      console.log(item)
      try {
        await PeriodsService.delete(item.id)
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: 'Error al intentar eliminar periodo',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      }
    },
    async guardarEditarPeriodo () {
      let periodId = null
      console.log(this.editItem)
      if (this.editItem.id === '') {
        periodId = await PeriodsService.create({
          x_name: this.editItem.x_name,
          x_start_date: this.editItem.x_start_date,
          x_end_date: this.editItem.x_end_date,
          x_type: this.editItem.x_type,
          x_year_id: this.selectedYear
        })
      } else {
        periodId = this.editItem.id
        await PeriodsService.update(periodId, {
          x_name: this.editItem.x_name,
          x_start_date: this.editItem.x_start_date,
          x_end_date: this.editItem.x_end_date,
          x_type: this.editItem.x_type,
          x_year_id: this.editItem.x_year_id[0]
        })
      }
      for (let i = 0; i < this.editItem.x_score_types.length; i++) {
        const st = this.editItem.x_score_types[i]
        if (st.x_promotion !== '') {
          st.x_promotion = parseInt(st.x_promotion)
        }
        const updateSt = {
          x_name: st.x_name,
          x_order: st.x_order,
          x_promotion: st.x_promotion,
          x_advanced_class: false,
          x_period_id: periodId
        }
        if (st.id !== undefined) {
          await ScoreTypeService.update(st.id, updateSt)
        } else {
          await ScoreTypeService.create(updateSt)
        }
      }
      for (let i = 0; i < this.editItem.x_score_types_adv.length; i++) {
        const st = this.editItem.x_score_types_adv[i]
        if (st.x_promotion !== '') {
          st.x_promotion = parseInt(st.x_promotion)
        }
        const updateSt = {
          x_name: st.x_name,
          x_order: st.x_order,
          x_promotion: st.x_promotion,
          x_advanced_class: true,
          x_period_id: periodId
        }
        if (st.id !== undefined) {
          await ScoreTypeService.update(st.id, updateSt)
        } else {
          await ScoreTypeService.create(updateSt)
        }
      }
      this.editItem = {}
    },
    nuevaScoreTypeInf () {
      this.isLoading = true
      this.editItem.x_score_types.push({ x_name: '', x_order: '', x_promotion: '' })
      console.log(this.editItem)
      this.isLoading = false
    },
    async deleteScoreType (id) {
      console.log(await ScoreTypeService.delete(id))
    },
    nuevaScoreTypeSup () {
      this.isLoading = true
      this.editItem.x_score_types_adv.push({ x_name: '', x_order: '', x_promotion: '' })
      this.isLoading = false
    },
    nuevoPeriodo () {
      this.editItem = {
        id: '',
        x_name: '',
        x_start_date: '',
        x_end_date: '',
        x_type: '',
        x_score_types: [

        ],
        x_score_types_adv: [

        ]
      }
    },
    cancerlarEditarPeriodo () {
      this.editItem = {}
    },
    editarPeriodo (item) {
      console.log(item)
      this.editItem = item
      // this.editing =
    },
    async configurarPopUp (item) {
      this.isLoading = true
      this.modalItem = item
      this.selectedYear = item.id
      this.modalPeriods = await PeriodsService.list({ x_year_id: item.id })
      for (let i = 0; i < this.modalPeriods.length; i++) {
        this.modalPeriods[i].x_score_types = await ScoreTypeService.list({ x_period_id: this.modalPeriods[i].id, x_advanced_class: false })
        for (let j = 0; j < this.modalPeriods[i].x_score_types.length; j++) {
          this.modalPeriods[i].x_score_types[j].x_promotion = this.modalPeriods[i].x_score_types[j].x_promotion[0]
        }
        this.modalPeriods[i].x_score_types_adv = await ScoreTypeService.list({ x_period_id: this.modalPeriods[i].id, x_advanced_class: true })
        for (let j = 0; j < this.modalPeriods[i].x_score_types_adv.length; j++) {
          this.modalPeriods[i].x_score_types_adv[j].x_promotion = this.modalPeriods[i].x_score_types_adv[j].x_promotion[0]
        }
      }

      console.log(this.modalPeriods)
      this.isLoading = false
      this.modalTitle = 'Configurar Año ' + item.x_year
      this.$bvModal.show('modal-configure-year')
    },
    updateLista: async function () {
      try {
        this.years = await YearsService.list({}, [], { order: 'id asc' })
        // console.log('años ----- ', this.years)
      } catch (error) {
        console.log(error)
      }
    },
    syncYear: async function () {
      try {
        const years = await YearsService.list({}, [], { order: 'id asc' })
        console.log('años ----- ', years)
        if (years) {
          for (let i = 0; i < years.length; i++) {
            console.log(years[i].id, 'name: ', years[i].display_name)
            if (years[i].display_name === 'False') {
              console.log('el año ', years[i].x_year, 'no tiene display name, debería ser ', years[i].x_year)
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
